import React from 'react'
import styled from 'styled-components'
import Image from 'common/image'
import { useSelector } from 'react-redux'
import StepArrow from 'assets/step_arrow.svg'
import { useTranslation } from 'react-i18next'
import { adobeInteractionEvent } from 'utils/adobewa'

const BoxContainer = styled.div`
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    width: 1164px;
    padding: 48px;
    justify-content: flex-start;
    align-items: flex-start;
    border-radius: 50px;
    background-color: #fff;
    box-shadow: 1px 1px 15px 0 rgba(0, 0, 0, 0.1);
`

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 56px;
`

const TitleText = styled.div`
    color: #121b21;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
`

const TitleUnderLine = styled.div`
    width: 80px;
    height: 5px;
    background: #d9c277;
`

const FirstLineText = styled.div`
    margin-top: 40px;
    color: var(--Secondary-Color-Dark-Brown, #4e3821);
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 35px; /* 175% */
`

const SecondLineText = styled.div`
    margin-top: 16px;
    color: var(--Secondary-Color-Dark-Brown, #4e3821);
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px; /* 125% */
`

const PrioirtyCardDisplayRow = styled.div`
    margin-top: 40px;
    width: 1068px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0px 45px;
`

const PriorityDisplayCardItem = styled.div``

const CardTierText = styled.div`
    color: var(--Secondary-Color-Dark-Brown, #4e3821);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */

    margin-bottom: 24px;
`

const ProgressBarContainer = styled.div`
    margin-top: 32px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-self: center;
    gap: 126px;
`

const ProgressCardItemContainer = styled.div`
    height: 40px;
    align-self: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`

const ProgressCardItem = styled.div`
    width: 40px;
    height: 75px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

interface Props {
    $color: string
}

const ProgressNumber = styled.div`
    width: 86px;
    color: var(--Secondary-Color-Dark-Grey, #606060);
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 35px; /* 175% */
`

const ProgressBar = styled.div<Props>`
    width: 172px;
    height: 6px;
    border-radius: 8px 0 0 8px;
    background: ${(p) => p.$color};
`

const UnlockText = styled.div`
    margin-top: 35px;
    color: var(--Secondary-Color-Dark-Brown, #4e3821);
    text-align: center;
    align-self: center;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px; /* 125% */
`

const TierBenefitContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 24px;
    width: 100%;
    display: flex;
    padding: 32px 24px 40px 24px;
    border-top: 1px solid #003c84;
    background: #fafafa;
    gap: 60px;
`

const TierBenefitItemRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`

const TierBenefitItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 296px;
    gap: 12px;
`

const TierBenefitItemText = styled.div`
    min-height: 69px;
    color: var(--Brand-Color-Black, #121b21);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 23px; /* 143.75% */
`

interface TierBenefitButtonProps {
    $color: string
}

const TierBenefitItemButton = styled.div<TierBenefitButtonProps>`
    width: 180px;
    padding: 6px 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    background: ${(p) => p.$color};
    color: white;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 23px;
`

const ExploreButton = styled.div`
    margin-top: 40px;
    display: flex;
    width: 280px;
    height: 55px;
    padding: 8px 48px;
    justify-content: center;
    align-items: center;
    border-radius: 200px;
    background: var(--Brand-Color-Yellow, #c5924d);
    align-self: center;
    cursor: pointer;
`

const ExploreButtonText = styled.div`
    color: #fff;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */
`

// const PrivilegeTutorial = styled.div`
//     margin-top: 40px;
//     width: 100%;
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//     align-items: flex-start;
// `

// const VideoAreaContainer = styled.div`
//     width: 100%;
//     display: flex;
//     flex-direction: center;
//     justify-content: center;
// `

// const VideoArea = styled.div`
//     width: 695px;
//     height: 392px;
//     margin-top: 40px;
// `

const TutorialTextContainer = styled.div`
    margin-top: 40px;
`

const TutorialContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    padding: 40px 0px;
`

const StepContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-right: 40px;
    margin-left: 40px;
`

const StepText = styled.div`
    width: 247px;
    height: 50px;
    margin-top: 40px;
    color: #4e3821;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 50px; /* 125% */
`

const SubTitleText = styled.div`
    padding-top: 12px;
    color: #835d35;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */
`

const ContentText = styled.div`
    margin-top: 16px;
    color: #835d35;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px; /* 125% */
`

const StepArrowContainer = styled.div`
    display: flex;
    height: 558px;
`

export default function StatusPointAndTier() {
    const { i18n, t } = useTranslation('', {
        keyPrefix: 'priorityprogramme.statuspointandtier',
    })
    const lang = i18n.language
    const configs = useSelector((state: any) => state.config.configs)

    const exploreAllPrivilegeButtonClick = (url: string) => {
        window.open(url, '_blank')?.focus()
        adobeInteractionEvent({
            lang: lang,
            eventID: `prioritysite_click_Program_Privilege_Explore`,
        })
    }

    // const videoOnplay = (url: string) => {
    //     adobeInteractionEvent({
    //         lang: lang,
    //         eventID: `prioritysite_clickPlayVideo_Program_Tutorial_Video`,
    //         videoFileName: url,
    //     }) 
    // }

    return (
        <BoxContainer>
            <TitleContainer>
                <TitleText>{t(`STATUSPOINTS`)}</TitleText>
                <TitleUnderLine />
            </TitleContainer>
            <FirstLineText>{t(`Upgrading`)}</FirstLineText>
            <SecondLineText>
                {t(`PriorityProgramme`)} <br />
                {t(`Eachtieroffers`)}
            </SecondLineText>
            <PrioirtyCardDisplayRow>
                <PriorityDisplayCardItem>
                    <CardTierText>{t(`PriorityYellow`)}</CardTierText>
                    <Image
                        src={t(`yellowCardImage`)}
                        width={142}
                        height={91}
                        alt="Yellow Card"
                        style={{
                            borderRadius: '4px',
                            background: 'lightgray 50% / cover no-repeat',
                        }}
                    />
                </PriorityDisplayCardItem>
                <PriorityDisplayCardItem>
                    <CardTierText>{t(`PriorityRed`)}</CardTierText>
                    <Image
                        src={t(`redCardImage`)}
                        width={142}
                        height={91}
                        alt="Red Card"
                        style={{
                            borderRadius: '4px',
                        }}
                    />
                </PriorityDisplayCardItem>
                <PriorityDisplayCardItem>
                    <CardTierText>{t(`PrioritySilver`)}</CardTierText>
                    <Image
                        src={t(`silverCardImage`)}
                        width={142}
                        height={91}
                        alt="Silver Card"
                        style={{
                            borderRadius: '4px',
                        }}
                    />
                </PriorityDisplayCardItem>
                <PriorityDisplayCardItem>
                    <CardTierText>{t(`PriorityGold`)}</CardTierText>
                    <Image
                        src={t(`goldCardImage`)}
                        width={142}
                        height={91}
                        alt="Gold Card"
                        style={{
                            borderRadius: '4px',
                        }}
                    />
                </PriorityDisplayCardItem>
                <PriorityDisplayCardItem>
                    <CardTierText>{t(`PriorityBlack`)}</CardTierText>
                    <Image
                        src={t(`blackCardImage`)}
                        width={142}
                        height={91}
                        alt="Black Card"
                        style={{
                            borderRadius: '4px',
                        }}
                    />
                </PriorityDisplayCardItem>
            </PrioirtyCardDisplayRow>
            <ProgressBarContainer>
                <ProgressNumber>0</ProgressNumber>
                <ProgressNumber>6,000</ProgressNumber>
                <ProgressNumber>10,000</ProgressNumber>
                <ProgressNumber>30,000</ProgressNumber>
                <ProgressNumber>120,000</ProgressNumber>
            </ProgressBarContainer>
            <ProgressCardItemContainer>
                <ProgressCardItem>
                    <Image
                        src={t(`yellowCardIconImage`)}
                        width={52}
                        height={52}
                        alt="Yellow Card"
                        style={{
                            borderRadius: '0.5px',
                        }}
                    />
                </ProgressCardItem>
                <ProgressBar $color={`var(--Brand-Color-Red, #9B2541)`} />
                <ProgressCardItem>
                    <Image
                        src={t(`redCardIconImage`)}
                        width={52}
                        height={52}
                        alt="Red Card"
                        style={{
                            borderRadius: '0.5px',
                        }}
                    />
                </ProgressCardItem>
                <ProgressBar
                    $color={`var(--Silver-2, linear-gradient(90deg, #888989 0%, #AAAAAB 59%, #CBCBCB 100%))`}
                />
                <ProgressCardItem>
                    <Image
                        src={t(`silverCardIconImage`)}
                        width={52}
                        height={52}
                        alt="Silver Card"
                        style={{
                            borderRadius: '0.5px',
                        }}
                    />
                </ProgressCardItem>
                <ProgressBar
                    $color={`var(--Gold-Bar, linear-gradient(279deg, #AF944F 4.78%, #CAB273 96.85%))`}
                />
                <ProgressCardItem>
                    <Image
                        src={t(`goldCardIconImage`)}
                        width={52}
                        height={52}
                        alt="Gold Card"
                        style={{
                            borderRadius: '0.5px',
                        }}
                    />
                </ProgressCardItem>
                <ProgressBar $color={`var(--Brand-Color-Black, #121B21)`} />
                <ProgressCardItem>
                    <Image
                        src={t(`blackCardIconImage`)}
                        width={52}
                        height={52}
                        alt="Black Card"
                        style={{
                            borderRadius: '0.5px',
                        }}
                    />
                </ProgressCardItem>
            </ProgressCardItemContainer>
            <UnlockText>{t(`Unlockhigher`)}</UnlockText>
            <TierBenefitContainer>
                <TierBenefitItemRow>
                    <TierBenefitItem>
                        <Image
                            src={t(`yellowCardPrivilegeImage`)}
                            width={40}
                            height={40}
                            alt="Calendar Image"
                        />
                        <TierBenefitItemText>
                            {t(`yellowPrivilege`)}
                        </TierBenefitItemText>
                        <TierBenefitItemButton $color={' #D7A717'}>
                            {t(`yellowExclusiveText`)}
                        </TierBenefitItemButton>
                    </TierBenefitItem>
                    <TierBenefitItem>
                        <Image
                            src={t(`redCardPrivilegeImage`)}
                            width={40}
                            height={40}
                            alt="Calendar Image"
                        />
                        <TierBenefitItemText>
                            {t(`redPrivilege`)}
                        </TierBenefitItemText>
                        <TierBenefitItemButton $color={' #9B2541'}>
                            {t(`redExclusiveText`)}
                        </TierBenefitItemButton>
                    </TierBenefitItem>
                    <TierBenefitItem>
                        <Image
                            src={t(`silverCardPrivilegeImage`)}
                            width={40}
                            height={40}
                            alt="Calendar Image"
                        />
                        <TierBenefitItemText>
                            {t(`silverPrivilege`)}
                        </TierBenefitItemText>
                        <TierBenefitItemButton $color={' #AAAAAB'}>
                            {t(`silverExclusiveText`)}
                        </TierBenefitItemButton>
                    </TierBenefitItem>
                </TierBenefitItemRow>
                <TierBenefitItemRow>
                    <TierBenefitItem>
                        <Image
                            src={t(`goldCardPrivilegeImage`)}
                            width={40}
                            height={40}
                            alt="Calendar Image"
                        />
                        <TierBenefitItemText>
                            {t(`goldPrivilege`)}
                        </TierBenefitItemText>
                        <TierBenefitItemButton $color={' #CAB273'}>
                            {t(`goldExclusiveText`)}
                        </TierBenefitItemButton>
                    </TierBenefitItem>
                    <TierBenefitItem>
                        <Image
                            src={t(`blackCardPrivilegeImage`)}
                            width={40}
                            height={40}
                            alt="Calendar Image"
                        />
                        <TierBenefitItemText>
                            {t(`blackPrivilege`)}
                        </TierBenefitItemText>
                        <TierBenefitItemButton $color={' #121B21'}>
                            {t(`blackExclusiveText`)}
                        </TierBenefitItemButton>
                    </TierBenefitItem>
                    <TierBenefitItem>
                        <Image
                            src={t(`blackCard2PrivilegeImage`)}
                            width={40}
                            height={40}
                            alt="Calendar Image"
                        />
                        <TierBenefitItemText>
                            {t(`black2Privilege`)}
                        </TierBenefitItemText>
                        <TierBenefitItemButton $color={' #121B21'}>
                            {t(`black2ExclusiveText`)}
                        </TierBenefitItemButton>
                    </TierBenefitItem>
                </TierBenefitItemRow>
            </TierBenefitContainer>
            <ExploreButton
                onClick={() =>
                    exploreAllPrivilegeButtonClick(t(`ExploreAllPrivilegeUrl`))
                }
            >
                <ExploreButtonText>
                    {t(`ExploreAllPrivilege`)}
                </ExploreButtonText>
            </ExploreButton>
            <TutorialTextContainer>
                <TitleContainer>
                    <TitleText>{t(`TUTORIALOFTIER`)}</TitleText>
                    <TitleUnderLine />
                </TitleContainer>
            </TutorialTextContainer>
            <TutorialContainer>
                {configs.priorityprogramme?.tutorialOfTierPrivileges?.map(
                    (item: any, index: string) => {
                        return (
                            <React.Fragment
                                key={`step-tutorial-privilege-` + index}
                            >
                                <StepContainer>
                                    <Image
                                        src={
                                            lang === 'zh'
                                                ? item.path_zh
                                                : item.path_en
                                        }
                                        width={275}
                                        height={468}
                                        alt="Step One Screen Picture"
                                    />
                                    <StepText>
                                        {lang === 'zh'
                                            ? item.step_zh
                                            : item.step_en}
                                    </StepText>
                                    {item.text_en ? (
                                        <SubTitleText>
                                            {lang === 'zh'
                                                ? item.text_zh
                                                : item.text_en}
                                        </SubTitleText>
                                    ) : null}
                                    <ContentText>
                                        {lang === 'zh'
                                            ? item.content_zh
                                            : item.content_en}
                                    </ContentText>
                                </StepContainer>
                                {index + 1 !==
                                configs.priorityprogramme
                                    ?.tutorialOfTierPrivileges?.length ? (
                                    <StepArrowContainer>
                                        <Image
                                            src={StepArrow}
                                            width={16}
                                            height={250}
                                            alt="Step Arrow Icon"
                                            style={{
                                                alignSelf: 'flex-end',
                                                flexShrink: '0',
                                            }}
                                        />
                                    </StepArrowContainer>
                                ) : null}
                            </React.Fragment>
                        )
                    }
                )}
            </TutorialContainer>
            {/* <PrivilegeTutorial>
                <TitleContainer>
                    <TitleText>{t(`TUTORIALOFPRIVILEGE`)}</TitleText>
                    <TitleUnderLine />
                </TitleContainer>
                <VideoAreaContainer>
                    <VideoArea>
                        <video
                            title="tutorial of earn wins"
                            controls
                            style={{
                                objectFit: 'cover',
                                width: '100%',
                                height: '100%',
                                borderRadius: '25px',
                            }}
                            src={t(`video`)}
                            onPlay={() => {
                                videoOnplay(t(`video`))
                            }}
                        />
                    </VideoArea>
                </VideoAreaContainer>
            </PrivilegeTutorial> */}
        </BoxContainer>
    )
}
